import styles from './ListWithIcon.module.scss';

type ListWithIconProps = {
  icon: React.ReactNode;
  title: string;
  listItems: string[];
};

const ListWithIcon = ({ icon, title, listItems }: ListWithIconProps) => {
  return (
    <div className={styles.listContainer}>
      {icon}
      <div className={styles.contentListContainer}>
        <p className={styles.title}>{title}</p>
        {listItems.length === 0 ? null : listItems.length > 1 ? (
          <ul className={styles.contentList}>
            {listItems.map(item => (
              <li key={item}>
                <p className={styles.contentItem}>{item}</p>
              </li>
            ))}
          </ul>
        ) : (
          <p className={styles.loneContentItem}>{listItems[0]}</p>
        )}
      </div>
    </div>
  );
};

export default ListWithIcon;
